
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.98 7H12.01C12.56 7 13 6.56 13 6.02V2.98C13 2.44 12.56 2 12.02 2H11.99C11.44 2 11 2.44 11 2.98V6.01C11 6.56 11.44 7 11.98 7ZM16.9 9.11C17.29 9.5 17.91 9.5 18.3 9.11C18.92 8.48 19.82 7.57 20.45 6.94C20.84 6.56 20.84 5.93 20.45 5.55C20.07 5.17 19.44 5.17 19.06 5.55L16.89 7.7C16.5 8.08 16.5 8.71 16.89 9.09L16.9 9.11ZM5.71003 9.1C6.09003 9.49 6.72003 9.49 7.11003 9.1C7.49003 8.72 7.49003 8.09 7.11003 7.71L4.96003 5.54C4.58003 5.15 3.95003 5.15 3.57003 5.54L3.55003 5.55C3.16003 5.94 3.16003 6.56 3.55003 6.94C4.18003 7.56 5.09003 8.47 5.71003 9.1ZM23.29 16.23C16.88 10.57 7.22003 10.57 0.81003 16.23C-0.0399702 16.98 -0.0399702 18.31 0.76003 19.11L1.98003 20.33C2.70003 21.05 3.84003 21.11 4.64003 20.48L6.64003 18.89C7.12003 18.51 7.40003 17.93 7.40003 17.32V14.72C10.42 13.74 13.69 13.73 16.72 14.72V17.33C16.72 17.94 17 18.52 17.48 18.9L19.47 20.48C20.27 21.11 21.41 21.05 22.13 20.33L23.35 19.11C24.14 18.31 24.14 16.98 23.29 16.23Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-ring-volume`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRingVolume

    ```js
    <b-new-b-icon-ring-volume />
    ```
</docs>


